import { initializeApp } from 'firebase/app'
import { getAnalytics } from 'firebase/analytics'
import { getAuth, connectAuthEmulator } from 'firebase/auth'
import { getFirestore, connectFirestoreEmulator } from 'firebase/firestore'
import { initializeAppCheck, ReCaptchaV3Provider } from 'firebase/app-check'

const firebaseConfig = {
  apiKey: "AIzaSyBkLdZtSrJmA-_em9hhrdvS406N5szRdM4",
  authDomain: "easyspeak-c8cfc.firebaseapp.com",
  projectId: "easyspeak-c8cfc",
  storageBucket: "easyspeak-c8cfc.firebasestorage.app",
  messagingSenderId: "806522607724",
  appId: "1:806522607724:web:e72ac524dd3e3a14752049",
  measurementId: "G-0XMLJC4RWM"
};

const firebaseApp = initializeApp(firebaseConfig)
const auth = getAuth(firebaseApp)
const db = getFirestore(firebaseApp)
const analytics = getAnalytics(firebaseApp);

auth.useDeviceLanguage()

// Connect to emulators in development mode
if (import.meta.env.MODE == 'development') {
  try {
    // Ensure this is only in development
    window.FIREBASE_APPCHECK_DEBUG_TOKEN = true

    // Connect to emulators
    // connectAuthEmulator(auth, 'http://localhost:9099')
    connectFirestoreEmulator(db, 'localhost', 8080)
  } catch (error) {
    console.warn('Emulator setup failed:', error)
  }
}

// Optional: App Check configuration
if (import.meta.env.MODE == 'production') {
  try {
    initializeAppCheck(firebaseApp, {
      provider: new ReCaptchaV3Provider('6Ldpf6srAAAAAF2f8zcPocpu_XU3mB4W4Wvu5VSt'),
      isTokenAutoRefreshEnabled: true
    })
  } catch (error) {
    console.warn('App Check initialization failed:', error)
  }
}

export { auth, db, analytics }
